<template>
  <hr :class="mini ? 'divider-mini' : 'divider'" />
</template>

<script>
export default {
  name: "DividerLine",
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.divider {
  height: 2.75px;
  width: 80%;
  margin: 1em auto;
}
.divider-mini {
  height: 1.75px;
  width: 60%;
  margin: 0.5em auto;
}
</style>
